/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Flex,
  Button,
  FormControl,
  FormLabel,
  Checkbox,
} from "@chakra-ui/react";
import { CASSETTES_DEFAULT } from "../constants";
import CassettesForm from "components/common/cassettes";
import { useState } from "react";

export default function Cassettes({
  addData,
  onNextStep,
  onPrevStep,
  cassettes,
  currencies,
  disabled,
  followStandardCassettes,
  toggleStandardCassettes,
}) {
  const [cassettesList, setCassettesList] = useState(cassettes);
  return (
    <>
      <Flex
        w="100%"
        justify="space-between"
        flexDirection="row"
        className="mb-2"
      >
        <Flex direction="column">
          <FormControl>
            <Checkbox
              isChecked={followStandardCassettes}
              onChange={() => {
                if (!followStandardCassettes) {
                  setCassettesList([]);
                }
                toggleStandardCassettes();
              }}
            >
              <FormLabel style={{ margin: 0, whiteSpace: "nowrap" }}>
                Follow Standard Cassette For Customers
              </FormLabel>
            </Checkbox>
          </FormControl>
          {disabled ? (
            <p
              className="error-message text-sm w-full black"
              style={{ whiteSpace: "nowrap" }}
            >
              Can Not Edit When Following Standard Cassettes
            </p>
          ) : (
            <></>
          )}
        </Flex>

        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex
            w="100%"
            justify="flex-end"
            flexDirection="row"
            gap="16px"
            onClick={() => {}}
          >
            <Button type="button" onClick={() => onPrevStep(cassettesList)}>
              Back
            </Button>
            <Button type="button" onClick={() => onNextStep(cassettesList)}>
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>

      <CassettesForm
        key={cassettesList.length}
        addData={(data) => {
          setCassettesList(data);
          addData(data);
        }}
        cassettes={cassettesList}
        currencies={currencies}
        disabled={disabled}
        toggleStandardCassettes={toggleStandardCassettes}
        followStandardCassettes={followStandardCassettes}
      />
    </>
  );
}
